import {notice} from "./UI/notice";

export const  changeInputFile = input => {
    if (input.files && input.files[0]) {
        let file = input.files[0];

        if (!file.type.match('image/*|application/pdf|application/msword|application/vnd.openxmlformats-officedocument.spreadsheetml.sheet|application/vnd.openxmlformats-officedocument.wordprocessingml.document|text/csv')) {
            notice('Формат файла не прошел проверку');
            input.value = "";
            return;
        }

        let js_form_file = input.closest('.js_form_file');
        if (js_form_file) {
            let js_form_file_list = js_form_file.querySelector('.js_form_file_list');
            if (js_form_file_list) {
                js_form_file_list.innerHTML = `<div class=" d-flex align-items-center mt-10 fw-bl gap-5">
                        <span class="fs-12">${file.name}</span>
                    </div>`;

                let js_form_remove_file = js_form_file.querySelector('.js_form_remove_file');
                if (js_form_remove_file) {
                    js_form_remove_file.addEventListener('click', () => {
                        js_form_file_list.innerHTML = "Выберите файл";
                        input.value = null;
                    });
                }
            }
        }
    }
};